module.exports = __webpack_public_path__ + "media/newstyle/images/instagram-share-pink-c2f0c4c56353931e733c5ebfcce30cd7.svg";